import React from 'react';
import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';
import {Navigate, useParams, useSearchParams} from 'react-router-dom';
import {useBff, useTrovoConfig} from '../../utils/config';
import CreateRnaAnalysis from './rna/CreateRnaAnalysis';
import {CreateFunctionalAnalysis} from './chip/functionalEnrichment/CreateFunctionalEnrichmentAnalysis';
import {CreateDefaultChipAnalysis} from './chip/default/CreateDefaultChipAnalysis';
import {CreateDifferentialBindingAnalysis} from './chip/dba/CreateDifferentialBindingAnalysis';
import {CreateMotifAnalysis} from './chip/motif/CreateMotifAnalysis';
import {Loading} from '../../components/Loading';
import {isDemoExperiment} from '../../utils/demo-data';

const ExpContainer = styled(Box)({
    display: 'flex',
    padding: '1.5% 8%',
    gap: 5
});

export const CreateAnalysisDispatch = () => {
    // Should this be used to shortcircuit demo users?
    const {user} = useTrovoConfig();
    const {id} = useParams();
    const [params] = useSearchParams();
    const mode = params.get('mode');

    const [experiment, _expError, isExperimentLoading] = useBff('GET', `experiment/${id}`);
    const [samples, _samplesError, isSamplesLoading] = useBff('GET', `experiment/${id}/sample`);

    if (isExperimentLoading || isSamplesLoading) {
        return <Loading />;
    }

    const isDemoAccount = user?.cb_item_price_id?.includes('demo');
    const isDemoExperimentId = id ? isDemoExperiment(id) : false;

    if (isDemoAccount || isDemoExperimentId) {
        return <Navigate to={`/experiment/${id}`} replace />;
    }

    samples.sort((a: any, b: any) => a.name.localeCompare(b.name));

    if (experiment?.sequencing_type === 'RNA Seq') {
        return (
            <ExpContainer>
                <CreateRnaAnalysis experiment={experiment} samples={samples} />
            </ExpContainer>
        );
    } else if (experiment?.sequencing_type === 'ChIP Seq') {
        // Can check for analysis_count to be 0 to default to
        // CreateDefaultChipAnalysis. Let user choose analysis otherwise.
        if (mode === 'functionalAnalysis' && experiment?.analysis_count !== '0') {
            return (
                <ExpContainer>
                    <CreateFunctionalAnalysis experiment={experiment} samples={samples} />
                </ExpContainer>
            );
        } else if (mode === 'differentialBindingAnalysis' && experiment?.analysis_count !== '0') {
            return (
                <ExpContainer>
                    <CreateDifferentialBindingAnalysis experiment={experiment} samples={samples} />
                </ExpContainer>
            );
        } else if (mode === 'motifAnalysis' && experiment?.analysis_count !== '0') {
            return (
                <ExpContainer>
                    <CreateMotifAnalysis experiment={experiment} />
                </ExpContainer>
            );
        }
        return (
            <ExpContainer>
                <CreateDefaultChipAnalysis experiment={experiment} samples={samples} />
            </ExpContainer>
        );
    } else if (!experiment) {
        return <ExpContainer>Experiment not found.</ExpContainer>;
    } else {
        return <ExpContainer>Unsupported sequencing type: {experiment?.sequencing_type}</ExpContainer>;
    }
};
